module.exports = __webpack_public_path__ + "img/banner_m.29e363cc.png";